/* eslint-disable no-console */
import React, {useEffect, useState} from 'react';

// import {roundToDecimal} from '../netZero/constants/commonFunctions';

const SVGBoundingBox: React.FC<{
  isPDF: boolean;
  polygons: Array<{score: number; value: any; page: number}>;
  imageDimension: {width: number; height: number};
  page: number;
}> = ({polygons, imageDimension, page}) => {
  const {width, height} = imageDimension;
  const [render, setRender] = useState<any[]>([]);

  useEffect(() => {
    setRender(
      polygons
        .filter((item) => {
          return item.page === page;
        })
        .map((item: any) => {
          const color =
            item.score > 90
              ? 'green'
              : item.score > 50 && item.score < 90
                ? '#ffd7b5'
                : '#950606';

          const allValue = item.value
            .map(
              (coord: {X: number; Y: number}) =>
                `${coord.X * width},${coord.Y * height}`
            )
            .join(' ');

          return {color, renderPoly: allValue, ...item};
        })
    );
  }, [page]);

  return (
    <svg
      width={imageDimension.width}
      height={imageDimension.height}
      style={{background: 'transparent', position: 'absolute', top: 0, left: 0}}
    >
      {render.map((polygon, index) => {
        return (
          <React.Fragment key={index}>
            <polygon
              points={polygon.renderPoly}
              style={{fill: 'none', stroke: polygon.color, strokeWidth: 1.5}}
            />
            {/* <text
              x={boxCenterX}
              y={boxBottomY + 6} // Position 20 units below the bottom of the box
              textAnchor="middle"
              fontSize="10"
              fontWeight="bold"
              fill="black"
            >
              {roundToDecimal(polygon.score)}
            </text>  */}
          </React.Fragment>
        );
      })}
    </svg>
  );
};

export default SVGBoundingBox;
